<template>
  <div class="profile-container">
    <div class="container">
      <div class="info-container">
        <div class="user">
          <img :src="user.avatar | default_img" alt="" />
          <div class="info">
            <div class="name">{{ user.nickname || user.username }}</div>
            <div class="job-location">
              <span>{{ user.job }}</span>
              <span v-if="userInfo.city">IP属地:{{ userInfo.city }}</span>
            </div>
            <div class="fans-info">
              粉丝 <span>{{ user.fans_count }}</span
              >关注 <span>{{ user.follow_count }}</span>
              收藏与获赞 <span>{{user.cz_count}}</span>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <Button
            @click="$router.push({ name: 'ShopHome', query: { uid: code } })"
          >
            <div>
              <img
                src="../../assets/images/icon-shop-black.png"
                style="margin-right: 10px" alt="" />
              前往TA的服装店铺
            </div>
          </Button>
          <Button @click="onShareClick">分享</Button>
          <Button
            v-show="user.id != userInfo.id"
            @click="onFollowUser"
            :class="[has_follow ? 'followed' : '']"
            >{{ has_follow ? "已关注" : "关注Ta" }}</Button
          >
          <Button
            @mouseover.native="onMouseIn"
            @mouseleave.native="onMouseLeave"
            ref="moreButton"
          >
            <img src="../../assets/images/icon-more-btn.png" alt="" />
          </Button>
        </div>
        <div
          v-show="show_contact"
          class="contact-box"
          ref="contactBox"
          @mouseenter="onMouseIn"
          @mouseleave="onMouseLeave"
          @click="onSendMsg"
        >
          私信
        </div>
      </div>
      <div class="content-container">
        <div class="tab-menu">
          <div
            class="tab-item"
            :class="[current_tab == 1 ? 'active' : '']"
            @click="current_tab = 1"
          >
            笔记<span>{{ user.create_count }}</span>
          </div>
          <!-- <div
            class="tab-item"
            :class="[current_tab == 2 ? 'active' : '']"
            @click="current_tab = 2"
          >
            收藏<span>{{ user.collect_count }}</span>
          </div> -->
          <div
            class="tab-item"
            :class="[current_tab == 3 ? 'active' : '']"
            @click="current_tab = 3"
          >
            款式创建<span>{{ user.design_count }}</span>
          </div>
        </div>
      </div>
      <div class="list-box">
        <template v-if="current_tab != '3'">
          <div
            class="masonry-container"
            style="margin-top: 30px; padding-bottom: 70px"
          >
          <!-- :gutter="{
                default: '20px',
                1600: '10px',
                1300: '10px',
                700: '15px',
                400: '10px',
              }" -->
              <!-- :gutter="'20px'" -->
            <masonry
              :cols="{ default: 6, 1600: 5, 1300: 4, 700: 3, 400: 2 }"
              style="display:flex;column-gap:20px;"
              
            >
              <div
                v-for="(item, index) in infiniteList"
                :key="index"
                @click.prevent.stop="onArticleDetail(item)" style="width:100%;display:flex;justify-content:center;"
              >
                <template>
                  <div class="masonry-item">
                    <img
                      v-if="item.type == 2"
                      src="../../assets/images/icon-play.png"
                      class="play-btn"
                      alt=""
                    />
                    <!-- <img src="../../assets/images/icon-match-on-list.png" class="match-ico" alt="" /> -->
                    <!-- <div class="remove-collect" @click.prevent.stop="onCollectRemove(item)">移除<Icon
                                            type="md-close"></Icon>
                                    </div> -->
                    <div class="img-container">
                      <img
                        :src="item.cover | default_img"
                        @load="onImageLoad"
                        class="masonry-image" :alt="item.title || item.name || ''" />
                    </div>
                    <div class="item-content">
                      <div class="title">{{ item.title }}</div>
                      <div class="bottom-box">
                        <div class="bottom-item">
                          <img
                            src="../../assets/images/icon-views-workbench-list.png" alt="" />
                          <div style="margin-left: 3px">
                            {{ item.view_times || 0 }}
                          </div>
                        </div>
                        <div class="bottom-item">
                          <img
                            src="../../assets/images/icon-comment-workbench-list.png" alt="" />
                          <div style="margin-left: 3px">
                            {{ item.comment_count || 0 }}
                          </div>
                        </div>
                        <div class="bottom-item">
                          <img
                            src="../../assets/images/icon-collect-workbench-list.png" alt="" />
                          <div style="margin-left: 3px">
                            {{ item.zan_count || 0 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </masonry>
          </div>
        </template>
        <template v-else>
          <div class="list">
            <div
              class="item"
              v-for="(v, k) in infiniteList"
              :key="`d` + k"
              @click="onProductDetail(v)"
            >
              <img :src="v.image | default_img" alt="" class="image" />
              <div class="name">{{ v.name }}</div>
              <div class="category">{{ v.product_category_name }}</div>
              <div class="desc">{{ v.description }}</div>
              <div class="time">{{ v.update_time }}</div>
              <div class="mask">
                <div class="icon-list">
                  <!-- <img
                    src="../../assets/images/icon_edit@2x.png"
                    alt="编辑"
                    class="icon-edit"
                    @click.stop="edit(v.uuid)"
                  />
                  <div
                    class="icon-unsale"
                    @click.prevent.stop="unsale(v.uuid)"
                    v-if="v.status == '1'"
                  >
                    <img
                      src="../../assets/images/icon-unsale.png"
                      alt="下架"
                      class="ico"
                    />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="article_id"
    ></ArticleDetail>
    <Chat ref="chat"></Chat>
  </div>
</template>
<script>
import { ProductList, ProfileNoAuth } from "@/api/index";
import { CheckFollow, FollowUser, GetProfileList } from "@/api/social";
import { applyUserSeo } from '@/seo/pageSeo';
import ArticleDetail from "@/components/ArticleDetail";
import infiniteMix from "@/mixins/infinite";
import { mapState } from "vuex";
//import Chat from "@/components/Chat.vue";
export default {
  data() {
    return {
      has_follow: false,
      show_contact: false,
      current_tab: 1,
      contactTimer: null,
      code: "",
      user: {},
      show_detail: false,
      article_id: "",
      loadingMore:false
    };
  },
  components: {
    ArticleDetail,
    //Chat,
  },
  mixins: [infiniteMix],
  computed: {
    ...mapState(["userInfo"]),
    is_login() {
      return this.$store.state.is_login;
    },
  },
  watch: {
    current_tab(val) {
      this.infiniteList = [];
      this.getInfiniteList(true);
    },
  },
  async mounted() {
    const { code } = this.$route.params;
    if (!code) {
      history.back();
      return;
    }
    this.code = code;
    document.addEventListener("click", this.handleClick);
    window.addEventListener("scroll", this.handleScroll);
    await this.onGetUserInfo();
    this.getInfiniteList(true);
    this.onCheckFollow();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClick);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onReachBottom:_.debounce(function(){
      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;
        console.log('offsetBottom',offsetBottom);
        if (offsetBottom <= 500) {
          if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
          console.log('触发触底加载...',new Date().getTime());
          this.loadingMore = true;
          this.getInfiniteList().finally(() => {
            this.loadingMore = false;
          });
        }
      });
    },100),
    handleScroll() {
      this.onReachBottom();
    },
    onProductDetail(data) {
      // ProductDetail
      this.$router.push({name:"ProductDetail",query:{uuid:data.uuid}})
    },
    onArticleDetail(data) {
      this.article_id = data.uuid.toString();
      this.show_detail = true;
    },
    onCloseArticleDetail(e) {
      console.log("关闭弹窗");
      this.show_detail = false;
    },
    async getInfiniteData(pageIndex, pageSize) {
      try {
        const { current_tab, user, code } = this;
        const { id } = user;
        const res = {};
        if (current_tab == 1) {
          const { data } = await GetProfileList({
            page: pageIndex,
            limit: pageSize,
            type: current_tab,
            uid: id,
          });
          res.data = data.list.length ? data.list : [];
        } else {
          const { data } = await ProductList({ code,status:'onsale',page:pageIndex,limit:pageSize });
          console.log("data", data);
          res.data = data.length ? data : [];
        }
        return res;
      } catch (e) {
        console.log("e", e);
      }
    },
    async onFollowUser() {
      try {
        if (!this.is_login) {
          this.$layer.msg("请先登录");
          this.$router.replace({ name: "Login" });
          return;
        }
        const { has_follow, user } = this;
        const { id } = user;
        if (has_follow) {
          this.$DModal.confirm({
            content: "确认取消关注么?",
            onOK: async () => {
              await FollowUser({ follow_id: id });
              this.has_follow = !has_follow;
              this.$layer.msg("操作成功");
            },
          });
        } else {
          await FollowUser({ follow_id: id });
          this.has_follow = !has_follow;
          this.$layer.msg("操作成功");
        }
      } catch (e) {
        console.log("e", e);
        this.$layer.msg("操作失败");
      }
    },
    async onCheckFollow() {
      if (!this.is_login) return;
      const { id } = this.user;
      const { data } = await CheckFollow({ follow_id: id });
      this.has_follow = data.check;
    },
    async onShareClick() {
      const text = `${window.location.href}`;
      await navigator.clipboard.writeText(text);
      this.$layer.msg("复制成功");
    },
    async onGetUserInfo() {
      try {
        const { code } = this;
        const { data } = await ProfileNoAuth({ code });
        this.user = data;
        applyUserSeo(data);
      } catch (e) {
        console.log(e);
      }
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    onSendMsg() {
      this.$refs["chat"].showChat(null, this.user);
    },
    onMouseLeave() {
      this.contactTimer = setTimeout(() => {
        this.show_contact = false;
      }, 500);
    },
    onMouseIn() {
      if(this.user.id == this.userInfo.id) {
        return
      }
      this.show_contact = true;
      if (this.contactTimer) {
        clearTimeout(this.contactTimer);
        this.contactTimer = null;
      }
    },
    handleClick(event) {
      if (
        this.show_contact &&
        !this.$refs.contactBox?.$el?.contains(event.target) &&
        !this.$refs.moreButton?.$el?.contains(event.target)
      ) {
        this.show_contact = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./profile.scss";
</style>
